import React, { useState } from 'react'
import { Switch, Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import orangeCheckMark from '../../../resources/orangeCheckMark.png'
import $t from '../../../i18n'
import Actions from '../../../actions'
import UseCouponDialogue from '../../pages/dialogs/UseCoupoDialogue'
import './PaymentPlanCard.css'
import config from '../../../config.json'
import { planSmallImage } from '../../../utils/paymentUtils'
import { planTypes } from '../../../consts'
import AddMedicationDescDialog from '../../pages/dialogs/AddMedicationDescDialog/AddMedicationDescDialog'
import { t } from '@transifex/native'

const PaymentPlanCard = props => {
  const [isPremium, setIsPremium] = useState(false)
  const isCouponDialogVisible = useSelector(
    state => state?.payment?.isCouponDialogVisible
  )
  const openDialog = () => {
    dispatch(Actions.createAction(Actions.COUPON_DIALOG_OPEN))
  }
  const closeDialog = () => {
    dispatch(Actions.createAction(Actions.COUPON_DIALOG_CLOSE))
  }
  const [
    isAddMedicationDescDialogVisible,
    setIsAddMedicationDescDialogVisible,
  ] = useState(false)
  const dispatch = useDispatch()

  const { plan } = props
  const { currency, id, payment_every, plan_name, banner_text, image_name } =
    plan

  const planDescription =
    t(plan_name) + $t('pages.getStarted.paymentPlanCard.includes')

  const allAvailablePlans = useSelector(state => state.payment.plans)
  const { checkoutErrorMessage } = useSelector(state => state.payment)
  const { locationState, isServiceInYourCountry } = useSelector(
    state => state.app
  )
  const isLocationVerified = useSelector(
    state => state.auth.locationVerification.state
  )
  const getPremiumPlan = () => {
    const prermium = allAvailablePlans.find(
      eachPlan => eachPlan?.id === plan?.premium?.id
    )
    if (prermium) {
      return prermium
    }
    return plan
  }

  // we should display premium plan if exist, if not display original plan
  const displayPlan = getPremiumPlan()

  const getCoupon = () => {
    const coupon = couponData.find(eachCoupon => {
      return eachCoupon.id === plan.id
    })
    return coupon ? coupon : null
  }

  const { selectedPlan, isLoadingCheckoutPage, couponData } = useSelector(
    state => state.payment
  )

  const togglePremiumPlanStatus = status => {
    setIsPremium(status)
  }

  const renderPaymentPlanTitle = () => (
    <div className="payment-plan-title-container">
      <span className="plan-name semi-bold">{t(plan_name)}</span>
    </div>
  )

  const renderPaymentPlanDescription = () => {
    return plan.plan_name ? (
      <div className="payment-plan-description">{planDescription}</div>
    ) : null
  }

  const renderBulletPoints = () => {
    return (
      <div className="bullets-container">
        {displayPlan?.bullets.map((eachBullet, i) => {
          return (
            <div key={`${id}-${i}`} className="bullet-point-container">
              <img
                className="bullet-check-mark"
                src={orangeCheckMark}
                alt="check-mark"
              />
              <span className="bullet-point">{t(eachBullet)}</span>
            </div>
          )
        })}
        {plan.premium ? renderPremiumPlanDescription(plan.premium) : null}
      </div>
    )
  }

  const getPlanIcon = () => {
    return (
      <img
        className="plan-icon"
        src={planSmallImage(image_name).uri}
        alt="plan-icon"
      />
    )
  }

  const renderPremiumPlanDescription = premium => {
    const { id } = premium
    return (
      <div key={id.toString()} className="premium-plan-toggle-switch-container">
        {false && (
          <Switch
            size="small"
            className={
              isPremium
                ? 'toggle-switch-button'
                : 'toggle-switch-button-disabled'
            }
            checked={isPremium}
            onChange={togglePremiumPlanStatus}
          />
        )}
      </div>
    )
  }

  const renderHrLine = () => <hr className="horizontal-line" />

  const renderPriceDescription = () => {
    return (
      <div className="price-description-container">
        {plan.price_note ? <span></span> : null}
        <span className="plan-price-text extra-light">
          {renderCurrencySymbol()}
          {displayPlan?.price}
        </span>
        {!!payment_every && (
          <span className="plan-price-duration extra-light">
            {t(payment_every)}
          </span>
        )}
      </div>
    )
  }

  const renderCurrencySymbol = () => {
    switch (currency) {
      default:
        return $t('pages.getStarted.paymentPlanCard.currency.usd')
    }
  }

  const handleChoosePayment = () => {
    const coupon = getCoupon()

    dispatch(
      Actions.createAction(Actions.PAYMENT_PLAN_SELECTED_FROM_PLANS, {
        selectedPlan: displayPlan,
        customerCoupon: coupon?.code,
      })
    )
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'plan_selected_web',
        data: { ...plan },
      })
    )
    if (coupon && coupon.give_full_discount) {
      openDialog()
    } else {
      if (isLocationVerified) {
        dispatch(Actions.createAction(Actions.SKIP_LOCATION_VERIFICATION))
      } else {
        dispatch(Actions.createAction(Actions.LOCATION_VERIFICATION_STARTED))
        dispatch(
          Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
            eventName: Actions.LOCATION_VERIFICATION_STARTED,
            data: {
              origin: 'plan',
            },
          })
        )
      }
    }
  }

  const handleRemoveCoupon = () => {
    dispatch(
      Actions.createAction(Actions.REMOVE_COUPON_CODE, {
        id: plan.id,
      })
    )
  }

  const renderUseCouponButton = () => {
    const validCoupon = getCoupon()
    if (validCoupon) {
      return (
        <div className="valid-coupon-code-text">
          <span>
            {$t('pages.getStarted.paymentPlanCard.couponCode')} : &nbsp;{' '}
            {validCoupon.code}
          </span>
          <span className="remove-coupon" onClick={handleRemoveCoupon}>
            {$t('pages.getStarted.paymentPlanCard.remove')}
          </span>
        </div>
      )
    }

    return (
      <div className="use-coupon-button" onClick={() => openDialog()}>
        {$t('pages.getStarted.paymentPlanCard.useCoupon')}
      </div>
    )
  }

  const renderTermsOfUse = () => {
    if (plan.type === planTypes.MEDICAL_FILE) {
      const reviewTextWithLink = plan?.terms.split('[link]')
      return (
        <div className="payment-card-terms-of-use">
          <div className="center">
            {t(reviewTextWithLink?.[0])}
            <a href={config.medicalNotePolicy} target="_blank">
              {$t('pages.getStarted.paymentPlans.medicalNotePolicy')}
            </a>
            {t(reviewTextWithLink?.[1])}
          </div>
        </div>
      )
    } else if (plan.is_membership) {
      return (
        <div className="payment-card-terms-of-use">
          <div className="center">
            {$t(
              'pages.getStarted.paymentPlans.byChoosingThisPlanYouAgreeToOur'
            )}
            <a href={config.plansTermsURL} target="_blank">
              {$t('pages.getStarted.paymentPlans.termsOfUse')}
            </a>
          </div>
          <br />
          {t(displayPlan.terms)}
        </div>
      )
    } else {
      return <div className="payment-card-terms-of-use">{t(plan?.terms)}</div>
    }
  }

  const renderMoreInfo = () => {
    const learnMore = displayPlan?.lean_more_info
    if (learnMore?.includes('[link]')) {
      const learmMoreArray = displayPlan?.lean_more_info?.split('[link]')
      return (
        <div>
          {learmMoreArray?.[0]}
          <a href={config.plansTermsURL} target="_blank">
            {'Subscription Terms of Use'}
          </a>
          {learmMoreArray?.[1]}
        </div>
      )
    } else {
      return learnMore
    }
  }

  const getErrorMessage = () => {
    if (checkoutErrorMessage && checkoutErrorMessage.id === plan.id) {
      return checkoutErrorMessage.message
    }
    return null
  }

  // const getdiscountBadge = () =>
  //   banner_text ? <div className="discountBadge">{banner_text}</div> : null

  const getdiscountBadge = () =>
    banner_text ? (
      <div className="save-flag-container">
        <div className="discountBadge">{banner_text}</div>
        <div className="save-flag-part"></div>
      </div>
    ) : null

  const [expand, setExpand] = useState(false)
  const handlePaymentCardContent = () => {
    setExpand(!expand)
  }
  return (
    <>
      <div className="payment-card-container">
        <div className="payment-card" onClick={handlePaymentCardContent}>
          <div>
            {renderPaymentPlanTitle()}
            {renderPriceDescription()}
          </div>
          <div className="icon-discountBadge-container">
            {getPlanIcon()}
            {getdiscountBadge()}
          </div>
        </div>
        <div className="error-message">{getErrorMessage()}</div>
        {expand ? (
          <div className="payment-card-content-show">
            {renderHrLine()}
            {renderPaymentPlanDescription()}
            {renderBulletPoints()}
            <div className="choosePlanBtn">
              <Button
                onClick={handleChoosePayment}
                type="primary"
                loading={
                  selectedPlan &&
                  selectedPlan.id === plan.id &&
                  isLoadingCheckoutPage
                    ? true
                    : false
                }
              >
                {plan_name === 'One Time Visit'
                  ? t(plan_name)
                  : $t('pages.getStarted.paymentPlans.choose')}
              </Button>
            </div>
            {renderUseCouponButton()}
            <div className="error-message">{getErrorMessage()}</div>
            <UseCouponDialogue
              isCouponDialogVisible={isCouponDialogVisible}
              setIsCouponDialogVisible={closeDialog}
              plan={plan}
            />
            <AddMedicationDescDialog
              isAddMedicationDescDialogVisible={
                isAddMedicationDescDialogVisible
              }
              setIsAddMedicationDescDialogVisible={
                setIsAddMedicationDescDialogVisible
              }
              plan={plan}
            />
            {renderTermsOfUse()}
            {
              //TODO - THIS CODE IS TEMPORRATY - HOTFIX FOR PROD
              displayPlan?.lean_more_info && (
                <div className="payment-card-terms-of-use">
                  {' '}
                  {renderMoreInfo()}{' '}
                </div>
              )
            }
          </div>
        ) : null}
      </div>
    </>
  )
}

export default PaymentPlanCard
